import React from 'react'
import PersonProfileSimple from "./PersonProfileSimple"

const SectionTeam = () => {
  return (
    <div className="row">
      <PersonProfileSimple name="Li Xu" link="https://scholar.google.com/citations?user=eZWXOqYAAAAJ" title="" org="SUTD" />
      <PersonProfileSimple name="Mark He Huang" link="https://github.com/MarkHershey" title="" org="SUTD" />
      <PersonProfileSimple name="Jun Liu" link="https://scholar.google.com/citations?user=Q5Ild8UAAAAJ" title="" org="SUTD" />
      <PersonProfileSimple name="Tran Nguyen Bao Long" link="https://www.linkedin.com/in/tnbl265/" title="" org="SUTD" />
      <PersonProfileSimple name="Yutian Lin" link="https://www.linkedin.com/in/yutian-lin-4745721bb/" title="" org="SUTD" />
      <PersonProfileSimple name="Renhang Liu" link="https://www.linkedin.com/in/renhang-liu-39566519a/" title="" org="SUTD" />
      <PersonProfileSimple name="Yingjie Qiao" link="https://www.linkedin.com/in/yingjie-qiao/" title="" org="SUTD" />
      <PersonProfileSimple name="Xun Long Ng" link="https://scholar.google.com/citations?user=7wcY9PYAAAAJ" title="" org="SUTD" />
      <PersonProfileSimple name="Koh Kai Ting" link="https://www.linkedin.com/in/kai-ting-koh-b814bb194/" title="" org="SUTD" />
      <PersonProfileSimple name="Christabel Dorothy" link="https://www.sutd.edu.sg/" title="" org="SUTD" />
    </div>
  )
}



export default SectionTeam
